import { Box } from "@mui/material"
import { useState } from "react";
import { StyledClientFilterItem } from "views/tasks/Filters/styles";
import PanNewUpdates from "./pan-new-updates";
import ComplianceNewUpdates from "./Compliance/compliance-new-updates";


const NewUpdates = () => {
    const [active, setActive] = useState("pan-reports");

    return (
        <Box pl={1} pr={1} mt={0} pt={0}>
            <Box pl={2} pr={2} mb={0} mt={0} pt={0} pb={0} display="flex" justifyContent="center" alignItems="center"  flexWrap="wrap"
                bgcolor="#F5F5F5">
                <Box display="flex" gap="15px" flexWrap="wrap" alignItems="center" p={2}>
                    <StyledClientFilterItem
                        variant="body1"
                        color="rgba(0,0,0,0.7)"
                        active={active === "pan-reports" ? 1 : 0}
                        onClick={() => setActive("pan-reports")}
                    >
                        e-Filing
                    </StyledClientFilterItem>
                    <StyledClientFilterItem
                        variant="body1"
                        color="rgba(0,0,0,0.7)"
                        active={active === "compliance-reports" ? 1 : 0}
                        onClick={() => setActive("compliance-reports")}
                    >
                        Compliance 
                    </StyledClientFilterItem>
                </Box>
            </Box>
            {active === "pan-reports" && <PanNewUpdates />}
            {active === "compliance-reports" && <ComplianceNewUpdates />}
        </Box>
    )
}


export default NewUpdates;